import React from "react";

export function WorkHistory() {
	return <div>Work History page</div>;
}

//<Link to={`work-history/${id}}>component card</Link>
